// E-Ticaret › Şubeler (Şube Görünümü) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.branches';

export const ecommerceBranchesGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Şubeler sitede nasıl gösterilir?'),
  intro: t(`${G}.intro`, 'Şubelerinizin e-ticaret sitesindeki şubeler sayfasında nasıl görüneceğini burada ayarlarsınız: sayfa şablonu, başlık, renkler, kart logoları ve her şubenin çalışma saatleri, görseli, harita konumu, sırası ve görünürlüğü. Şubenin kendisi (adı, adresi, telefonu) Şubeler sayfasından eklenir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Şube Görünümü'),
    form: t(`${G}.regions.form`, 'Şablon, bölüm ayarları ve logolar'),
    list: t(`${G}.regions.list`, 'Şube kartları'),
    footer: t(`${G}.regions.footer`, 'Satırdaki Kaydet'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Sayfa şablonu ve başlık'),
      text: t(`${G}.s1.text`, '"Şube Sayfası Şablonu"ndan bir şablona tıkladığınızda hemen kaydedilir; vitrinde görmek için şubeler sayfasını yenileyin. Klasik şablonda pinli harita, şehir filtresi ve altta tüm şube kartları; İl Haritası şablonunda şubesi olan illerin boyandığı Türkiye haritası kullanılır. "Şube Sayfası Bölüm Ayarları"nda üst başlık alanını açıp Başlık ve Açıklama yazın ve "Kaydet"e basın.'),
      tips: [
        t(`${G}.s1.tip1`, '"Üst alan arka planı" ve "Harita ve vurgu rengi" seçildiği anda kaydedilir. Harita rengi boş bırakılırsa sitenin ana rengi kullanılır.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Kart logoları'),
      text: t(`${G}.s2.text`, '"Kart Logoları" bölümünde "Marka logoları" ve "Ödeme ikonları" için "Ekle" ile görsel seçin; oklarla sıralayın, çöp kutusuyla kaldırın. Bu logolar tüm şube kartlarında aynıdır. Değişiklikten sonra üstteki "Kaydet"e basın.'),
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Şubeyi bulun'),
      text: t(`${G}.s3.text`, '"Filtreler" çipleriyle Tümü, Aktif veya Pasif şubeleri gösterin; "Şehir" ile bir şehre daraltın; "Şube Ara" kutusuna şube adı, şehir, ilçe, adres veya telefon yazın. Liste uzunsa altta sayfalar arasında gezinin ve "Sayfa başına" sayısını seçin.'),
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Adres ve harita linki'),
      text: t(`${G}.s4.text`, '"Harita Linki (Google Maps)" alanına şubenin Google Maps konum linkini yapıştırın ya da "Haritadan Seç" ile haritada konumu işaretleyin ("Konum Ara" veya "Adresten Bul" ile arayabilirsiniz). Vitrindeki "Yol Tarifi" bu konumu açar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Adres varsa ve harita boşsa, satır kaydedilirken konum adresten otomatik üretilir. "Eksik konumları adresten doldur" bunu tüm şubeler için tek seferde yapar.'),
        t(`${G}.s4.tip2`, '"Harita Önizleme" girilen konumları haritada gösterir; konum seçimini kontrol etmek içindir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Çalışma saatleri ve görsel'),
      text: t(`${G}.s5.text`, '"Çalışma saatleri" alanına saatleri yazın (ör. 09:00 - 22:00); şube gün boyu açıksa "7/24" anahtarını açın. "Seç" ile şube görseli seçin, çöp kutusuyla temizleyin. Çalışma saatleri, görsel ve harita kaydedilince vitrindeki şube kartına ve detay penceresine yansır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Sıra, görünürlük ve kaydetme'),
      text: t(`${G}.s6.text`, '"Sıra" şubenin listedeki yerini, "Göster / Gizli" anahtarı şubenin sitede görünüp görünmeyeceğini belirler. Satırdaki değişiklikler (saat, görsel, harita, sıra, görünürlük) ancak o satırın "Kaydet" düğmesine basınca kaydedilir.'),
      tips: [
        t(`${G}.s6.tip1`, '"Toplu işlemler" ile seçili (seçim yoksa filtrelenen) şubelerin hepsini tek seferde açabilir ("Pasifleri aç") ya da onay sorduktan sonra sitede gizleyebilirsiniz ("Pasif yap"); toplu işlem hemen kaydedilir.'),
        t(`${G}.s6.tip2`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
